import activityProcessingDayReducer from "./activityProcessingDayReducer";
import checklistReducer from "./checklistReducer";

const settingReducers = {
    activityProcessingDay: activityProcessingDayReducer,
    checklist: checklistReducer
}

export default settingReducers;